declare var HubSpotConversations: any;

import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { finalize } from "rxjs/operators";
import { environment as appEnv } from "../../../environments/environment";
import { EventService } from "../../event-service/event.service";
import { InstructionsService } from "../../models/instructions.service";
import { ProjectLanguageService } from "../../models/project-language.service";

@Component({ templateUrl: "./instructions-modal.component.html" })
export class InstructionsModalComponent implements OnInit {
  @Input() public project: any;

  public appEnv = appEnv;
  public loadingInstructions: boolean;
  public activeLanguagesTab: string;
  public hasSearchResult: boolean;
  public searchResult: { label: string; value: string }[];
  public Languages: {
    label: string,
    value: string,
    cardVisible: boolean,
    frameworks: { label: string, value: string }[]
  }[];
  public instructions: any;
  public selectedLanguage: { label: string; value: string };
  public showOtherLanguages = false;

  constructor(
    private instructionsService: InstructionsService,
    private projectLanguageService: ProjectLanguageService,
    private eventService: EventService,
    public activeModal: NgbActiveModal,
  ) { }

  public ngOnInit() {
    this.loadingInstructions = true;
    this.activeLanguagesTab = "ruby";
    this.Languages = [
      {
        label: "Ruby", value: "ruby", cardVisible: true,
        frameworks: [
          { label: "Rails", value: "rails" },
          { label: "Rack", value: "rack" },
          { label: "Sinatra", value: "sinatra" },
        ]
      },
      {
        label: "JavaScript", value: "javascript", cardVisible: true,
        frameworks: [
          { label: "AngularJS", value: "angularjs" },
          { label: "Angular", value: "angular" },
          { label: "Express", value: "express" },
          { label: "Node", value: "node" },
          { label: "React", value: "react" },
          { label: "Svelte", value: "svelte" },
          { label: "Vue.js", value: "vuejs" },
        ]
      },
      {
        label: "Java", value: "java", cardVisible: true,
        frameworks: []
      },
      {
        label: "Python",
        value: "python",
        cardVisible: true,
        frameworks: [
          { label: "AIOHTTP", value: "aiohttp" },
          { label: "BottlePy", value: "bottlepy" },
          { label: "Celery", value: "celery" },
          { label: "CherryPy", value: "cherrypy" },
          { label: "Django", value: "django" },
          { label: "Falcon", value: "falcon" },
          { label: "FastAPI", value: "fastapi" },
          { label: "Flask", value: "flask" },
          { label: "Hug", value: "hug" },
          { label: "Masonite", value: "masonite" },
          { label: "Morepath", value: "morepath" },
          { label: "Pycnic", value: "pycnic" },
          { label: "Pyramid", value: "pyramid" },
          { label: "Sanic", value: "sanic" },
          { label: "Starlette", value: "starlette" },
          { label: "Tornado", value: "tornado" },
          { label: "Turbogears2", value: "turbogears2" },
        ]
      },
      {
        label: "Go", value: "go",
        cardVisible: true,
        frameworks: [
          { label: "Beego", value: "beego" },
          { label: "Buffalo", value: "buffalo" },
          { label: "Echo", value: "echo" },
          { label: "FastHTTP", value: "fasthttp" },
          { label: "Fiber", value: "fiber" },
          { label: "Gin", value: "gin" },
          { label: "Gorilla", value: "gorilla" },
          { label: "Iris", value: "iris" },
          { label: "Negroni", value: "negroni" },
          { label: "Net/HTTP", value: "nethttp" },
        ]
      },
      {
        label: "PHP", value: "php", cardVisible: true,
        frameworks: [
          { label: "Magento", value: "magento" },
          { label: "Laravel", value: "laravel" },
          { label: "WordPress", value: "wordpress" },
        ]
      },
      {
        label: ".Net", value: "net", cardVisible: true,
        frameworks: []
      },
      {
        label: "Mobile App", value: "mobile", cardVisible: false,
        frameworks: [
          { label: "Android", value: "android" },
          { label: "iOS", value: "ios" },
          { label: "Swift", value: "swift" },
          { label: "React Native", value: "react-native" },
        ]
      },
      {
        label: "Other", value: "other", cardVisible: true,
        frameworks: []
      },
    ];

    if (this.project.language) {
      for (const language of this.Languages) {
        if (language.value === this.project.language) {
          this.fetchInstructions(language);
          this.activeLanguagesTab = language.value;
          break;
        }
        for (const lang of language.frameworks) {
          if (lang.value === this.project.language) {
            this.fetchInstructions(lang);
            this.activeLanguagesTab = language.value;
            break;
          }
        }
      }
    } else {
      this.loadingInstructions = false;
    }
  }

  public toggleOtherLanguages() {
    this.showOtherLanguages = !this.showOtherLanguages;
  }

  public trackByIndex(index: number, _item: any) {
    return index;
  }

  public fetchLanguageOrFramework(searchValue: string) {
    this.searchResult = [];
    if (searchValue === '') {
      this.hasSearchResult = false;
      return;
    } else {
      this.hasSearchResult = true;
    }
    for (const language of this.Languages) {
      if (language.label.toLowerCase().includes(searchValue.toLowerCase()) && language.cardVisible) {
        this.searchResult.push(language);
      }
      for (const lang of language.frameworks) {
        if (lang.label.toLowerCase().includes(searchValue.toLowerCase())) {
          this.searchResult.push(lang);
        }
      }
    }
  }

  public fetchInstructions(language: any) {
    this.selectedLanguage = language;
    const params = {
      projectId: this.project.id,
      language: this.selectedLanguage.value,
    };
    this.projectLanguageService
      .put(params)
      .pipe(
        finalize(() => {
          this.eventService.publish("language:changed", {
            projectId: this.project.id,
            language: this.selectedLanguage.value,
          });
        }),
      )
      .subscribe();
    this.instructionsService.get(params).subscribe((data: any) => {
      this.instructions = data.instructions;
      this.loadingInstructions = false;
    });
  }

  public resetInstructions() {
    this.activeLanguagesTab = this.getActivedLanguagesTab(this.selectedLanguage);
    delete this.selectedLanguage;
    this.instructions = false;
    this.hasSearchResult = false;
  }

  public onNeedHelpClick() {
    if (typeof HubSpotConversations !== "undefined") {
      HubSpotConversations.widget.open();
    } else {
      window.location.href = "mailto:support@airbrake.io";
    }
  }

  private getActivedLanguagesTab(languageSelected: any) {
    for (const language of this.Languages) {
      if (language.value === languageSelected.value) {
        return language.value;
      }
      for (const lang of language.frameworks) {
        if (lang.value === languageSelected.value) {
          return language.value;
        }
      }
    }
  }
}

